import { render, staticRenderFns } from "./wxtermschart.vue?vue&type=template&id=072382de&scoped=true&"
import script from "./wxtermschart.vue?vue&type=script&lang=js&"
export * from "./wxtermschart.vue?vue&type=script&lang=js&"
import style0 from "./wxtermschart.vue?vue&type=style&index=0&id=072382de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072382de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072382de')) {
      api.createRecord('072382de', component.options)
    } else {
      api.reload('072382de', component.options)
    }
    module.hot.accept("./wxtermschart.vue?vue&type=template&id=072382de&scoped=true&", function () {
      api.rerender('072382de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxtermschart.vue"
export default component.exports